import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { showFile } from 'actions/app';
import strings from 'strings';
import InfoLabel from 'UI/components/molecules/InfoLabel';

import {
  EMPTY_VALUE,
  formatCallDateTime,
  getDebriefFileName
} from '../interviewCallReadOnly.utils';

import { useStyles } from './DebriefingCallReadOnly.styled';

const COPIES = strings.sendoutsV2.drawers.sendoutInterviewDetails.calls;
const DEBRIEF_COPIES = strings.sendoutsV2.drawers.interviewDebrief;

const DebriefFileLink = ({ file }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleViewClick = () =>
    file?.url &&
    dispatch(showFile({ url: file.url, useProxy: true, explicitFileName: file.file_name }));

  return (
    <Button className={classes.fileButton} disableRipple onClick={handleViewClick} variant="text">
      {getDebriefFileName(file)}
    </Button>
  );
};

export const DebriefingCallReadOnly = ({ values }) => {
  const fields = [
    {
      title: COPIES.hiringAuthorityCall,
      description: formatCallDateTime(values?.hiringauthorityInterviewDate)
    },
    {
      title: COPIES.candidateCall,
      description: formatCallDateTime(values?.candidateInterviewDate)
    }
  ];
  const debriefs = [
    { file: values?.employerDebrief, title: DEBRIEF_COPIES.employer.title },
    { file: values?.candidateDebrief, title: DEBRIEF_COPIES.candidate.title }
  ];

  return (
    <Grid container spacing={2}>
      {fields.map(({ description, title }) => (
        <Grid item key={title} xs={6}>
          <InfoLabel title={title} description={description} mode="text" variant="body1" />
        </Grid>
      ))}
      {debriefs.map(({ file, title }) => (
        <Grid item key={title} xs={12}>
          <InfoLabel
            title={title}
            description={EMPTY_VALUE}
            mode="text"
            variant="body1"
            customValueRender={file ? <DebriefFileLink file={file} /> : null}
          />
        </Grid>
      ))}
    </Grid>
  );
};
